export default __webpack_public_path__ + "static/media/PROVIMENTO-169-2015.d4a0db04.pdf";